import { connect } from 'react-redux'
import PermissionsCheck from 'pages/documentscontent/PermissionsCheck'
import { setPrecedentId, setPrecedentSectionId, setPrecedentsExpandedSection, setPrecedentsView } from 'redux/actions'

const mapStateToProps = state => ({
  userDetails: state.user.details,
  isAdmin: state.user.isAdmin,
  isLogged: state.user.isLogged,
  isLimitedAccess: state.user.isLimitedAccess
})

const mapDispatchToProps = dispatch => ({
  setPrecedentId: precedentId => dispatch(setPrecedentId(precedentId)),
  setSectionId: sectionId => dispatch(setPrecedentSectionId(sectionId)),
  setView: view => dispatch(setPrecedentsView(view)),
  setExpandedSection: expandedSection => dispatch(setPrecedentsExpandedSection(expandedSection))
})

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsCheck)
